import * as yup from 'yup';
import { EmailValidation } from 'helpers/validations';

const signInFormValidation = yup.object().shape({
  name: EmailValidation(),
  password: yup.string().required(),
});
export default signInFormValidation;
